import { PropTypes } from 'prop-types'
import { toast } from 'react-toastify'

const useToast = () => {
	const showToast = (text, type) => {
		switch (type) {
			case 'success':
				toast.success(text)
				break
			case 'error':
				toast.error(text)
				break
			case 'warning':
				toast.warning(text)
				break
			default:
				toast(text)
				break
		}
	}
	return { showToast }
}

useToast.propTypes = {
	text: PropTypes.string,
	type: PropTypes.string,
}

export default useToast
